module.exports = __webpack_public_path__ + "img/gaji.b88420e6.png";